import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

import TEXT from '../../../utils/text/prensa.json'

export default function StepHeadlines({
  currentStepIndex,
  stepNumber,
  progress,
}) {

  const {language} = useCurrentLanguage();

  return (
    progress && (
      <>
       <div
          style={{
            
            top: "5%",
            position: 'sticky',
            // `${
            //   progress.data === stepNumber && progress.progress >0.5
            //     ? 100 - progress.progress * 50 /2
            //     : progress.data === stepNumber
            //     ? 100
            //     : -10
            // }%`,

            opacity:1
              // currentStepIndex < stepNumber - 1
              //   ? 0
              //   : currentStepIndex >= stepNumber
              //   ? 1
              //   : progress.progress !== 1
              //   ? progress.progress
              //   : 0,
          }}
          className={` font-bold font-md bg-blue sticky  mx-auto rounded-20 right-0 left-0 w-full md:w-[60%] z-50`}
        >
          <div
            id="headlines-container"
            className={`w-full md:py-10 p-4 md:px-24 flex-col z-20 font-sans text-lg md:text-xl desktop:text-2xl text-center font-medium text-white h-full transition-all `}
          >
            {TEXT['mixed_feelings']['step1'][language]}
          </div>
        </div>
        <div className="sticky  h-[50vh] mt-96"/>
        {/* <div className="relative"> */}
        <Parallax
          image={"/images/mixed-feelings/headlines/image1.png"}
          className={"top-14 left-4 w-[70%] md:w-[40vw]"}
          progress={progress}
          modifier={100}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image2.png"}
          className={"top-[30%]    left-6        w-[70%]  md:w-[30vw]"}
          progress={progress}
          modifier={200}
        />
        <Parallax 
          image={"/images/mixed-feelings/headlines/image6.png"}
          className={"top-[10%]  ml-auto right-2  md:right-12   w-[70%] md:w-[35vw]"}
          progress={progress}
          modifier={120}
        />   <Parallax
          image={"/images/mixed-feelings/headlines/image8.png"}
          className={"top-[60%] ml-auto   right-10       w-[65%] md:w-[30vw]"}
          progress={progress}
          modifier={250}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image3.png"}
          className={"top-[40%]    left-10      w-[60%]   md:w-[30vw]"}
          progress={progress}
          modifier={220}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image5.png"}
          className={"top-[80%]     left-[10rem]   w-[75%] md:w-[25vw]"}
          progress={progress}
          modifier={120}
        />{" "}

        <Parallax
          image={"/images/mixed-feelings/headlines/image4.png"}
          className={"top-[30%]    md:left-[40vh]    w-[70%] md:w-[40vw]"}
          progress={progress}
          modifier={230}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image7.png"}
          className={"top-[70%]    md:left-[40vh]     w-[60%] md:w-[40vw]"}
          progress={progress}
          modifier={90}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image9.png"}
          className={"top-[5%]    md:left-[36vh]   left-4  w-[70%] md:w-[30vw]"}
          progress={progress}
          modifier={400}
        />
        <Parallax
          image={"/images/mixed-feelings/headlines/image10.png"}
          className={"top-[40%]  ml-auto  right-[10vh]  w-[65%] md:w-[30vw]"}
          progress={progress}
          modifier={230}
        />
       
        {/* </div> */}
       
      </>
    )
  );
}

function Parallax({
  image,
  modifier,
  progress,
  className,
  currentStepIndex,
  stepNumber,
  ...others
}) {
  const p =
    currentStepIndex !== stepNumber
      ? 1
      : progress && progress.progress
      ? (progress.progress - 0.5) * modifier
      : 0;
  return (
    <img
      {...others}
      src={image}
      alt="parallax"
      style={{ transform: `translateY(${p}px)` }}
      className={`sticky transition-all duration-1000 ${className} 
      opacity-100
      `}
    />
  );
}
